import {clearResource, setResource} from 'redux/actions'
import reduxStore from 'redux/store'
import {RestRequestGET, RestRequestPOST} from "../libs/RestRequest";
import Endpoints from "../constants/Endpoints";

const DEMAND_ARCHIVING_RESOURCE_ID = 'demandArchiving';

const getDemandArchiving = async (demandId) => {
    const resp = await RestRequestGET(Endpoints.ARCHIVING(demandId));
    reduxStore.dispatch(setResource(DEMAND_ARCHIVING_RESOURCE_ID, resp))
}

const scheduleArchive = async (demandId) => {
    clearDemandArchiving();
    const resp = await RestRequestPOST(Endpoints.ARCHIVING_SCHEDULE(demandId));
    reduxStore.dispatch(setResource(DEMAND_ARCHIVING_RESOURCE_ID, resp))
}

const validate = async (demandId) => {
    return await RestRequestGET(Endpoints.ARCHIVING_VALIDATE(demandId));
}

const clearDemandArchiving = () => {
    reduxStore.dispatch(clearResource(DEMAND_ARCHIVING_RESOURCE_ID));
}

export default {
    getDemandArchiving,
    scheduleArchive,
    validate,
    clearDemandArchiving,
    DEMAND_ARCHIVING_RESOURCE_ID
}